// CustomButton.js
import React from 'react';
import styled from 'styled-components';

const Button = styled.a`
  display: inline-block;
  padding: 0.75rem 1.25rem;
  border-radius: 10rem;
  color: var(--Text-default-text, #0B2840);
  text-transform: uppercase;
  font-size: 1rem;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
  z-index: 1;
  cursor: pointer;
  text-decoration: none; /* Remove underline */
  font-family: 'Optima ExtraBlack', sans-serif;
  font-style: normal;
  font-weight: 600;
  @media only screen and (min-width: 992px) and (max-width: 1199.97px) {
    font-size: 14px;
    padding: 0.75rem 1rem;
  }
  &:after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: var(--Colors-Secondary-1, #FFAD03);
    border-radius: 10rem;
    z-index: -2;
  }
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0%;
    height: 100%;
    background-color: var(--Colors-Primary-2, #72369D);
    transition: all 0.3s;
    border-radius: 10rem;
    z-index: -1;
  }
  &:hover {
    color: #fff;
    &:before {
      width: 100%;
    }
  }
`;

const CustomButton = ({ children, ...props }) => {
  return <Button {...props}>{children}</Button>;
};

export default CustomButton;
